// import { Button } from '@nextui-org/react'
import { motion } from 'framer-motion'
import { FC, useEffect } from 'react'
// import { MdCalendarMonth } from 'react-icons/md'
import CalendarModal from './components/CalendarModal'
import Panel from './components/Panel'
import SolicitarInsumosModal from './components/SolicitarInsumosModal'
import TabsNav from './components/TabsNav'
import DashboardView from './components/views/DashboardView'
import DetalleTiendaView from './components/views/DetalleTiendaView'
import EtiquetasView from './components/views/EtiquetasView'
import HojaRutaView from './components/views/HojaRutaView'
import RepartoInternoView from './components/views/RepartoInternoView'
import IncumplimientosView from './components/views/IncumplimientosView'
import InsumosView from './components/views/InsumosView'
import TiendaAtrasadaView from './components/views/TiendaAtrasadaView'
import TodasAutomaticasView from './components/views/TodasAutomaticasView'
// import TodasSolicitudesView from './components/views/TodasSolicitudesView' // ruta comentada · archivo conservado
import TodoInventarioView from './components/views/TodoInventarioView'
import TodosEnviosView from './components/views/TodosEnviosView'
// import TrackingView from './components/views/TrackingView' // tab "Tracking" comentado · se conserva el archivo
import TrackingInsumosView from './components/views/TrackingInsumosView'
import RecoleccionTrackingView from './components/views/RecoleccionTrackingView'
import EnvioDetalleView from './components/views/EnvioDetalleView'
import ReglasView from './components/views/ReglasView'
import RecepcionView from './components/views/RecepcionView'
import RecepcionDetalleView from './components/views/RecepcionDetalleView'
import { useLogisticBox } from './context/LogisticBoxContext'
import { LogisticBoxView } from './models'

const VIEW_MAP: Record<LogisticBoxView, FC> = {
  dashboard: DashboardView,
  etiquetas: EtiquetasView,
  // tracking: TrackingView, // tab "Tracking" comentado · fusionado en "Recolecciones"
  insumos: InsumosView,
  incumplimientos: IncumplimientosView,
  reglas: ReglasView,
  discrepancias: RecepcionView,
  'recepcion-detalle': RecepcionDetalleView,
  'detalle-tienda': DetalleTiendaView,
  'tienda-atrasada': TiendaAtrasadaView,
  // 'todas-solicitudes': TodasSolicitudesView, // ruta comentada · solicitudes paginadas dentro de Insumos (archivo conservado)
  'todos-envios': TodosEnviosView,
  'todo-inventario': TodoInventarioView,
  'todas-automaticas': TodasAutomaticasView,
  'tracking-insumos': TrackingInsumosView,
  'envio-detalle': EnvioDetalleView,
  'recoleccion-tracking': RecoleccionTrackingView,
  'recolecciones-internas': HojaRutaView,
  'reparto-interno': RepartoInternoView
}

const LogisticBoxPage: FC = () => {
  // const { activeView, openCalendar } = useLogisticBox()
  const { activeView } = useLogisticBox()

  const ActiveView = VIEW_MAP[activeView]

  // Al cambiar de vista, volver al inicio (igual que la maqueta).
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [activeView])

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.3 }}
      className='space-y-4'
    >
      {/* Header del módulo */}
      <div className='flex items-center justify-between gap-4 flex-wrap'>
        <div>
          <h1 className='text-2xl font-medium text-[#151930]'>Logística de cajas</h1>
          <p className='text-xs text-[#151930]/60 mt-0.5'>
            Módulo de control y gestión de recoleccion de cajas e insumos
          </p>
        </div>
        {/* <Button
          hidden // componente calendario desactivado por ahora
          variant='bordered'
          className='border-gray-200 bg-white text-[#151930] text-sm d-none'
          startContent={<MdCalendarMonth />}
          onPress={openCalendar}
        >
          Calendario
        </Button> */}
      </div>

      {/* Tabs */}
      <Panel className='!p-3'>
        <TabsNav />
      </Panel>

      {/* Vista activa */}
      <ActiveView />

      {/* Modales globales del módulo */}
      <CalendarModal />
      <SolicitarInsumosModal />
    </motion.div>
  )
}

export default LogisticBoxPage
